module.exports = __webpack_public_path__ + "static/media/ecwid.78016576.png";